export const APP_TITLE = "AMAL BANK"
export const SECRET_KEY = 'secret key 123'